import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "onboarding-step" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "ai-section" }
const _hoisted_4 = { class: "ai-input-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "manual-section" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }

import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { aiAPI } from '@/api'
import { handleError } from '@/utils/errorHandler'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

interface StepData {
  name: string
  toneOfVoice: string
  styleGuide: string
  speechPatternGuidelines: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStep3',
  props: {
    initialData: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()
const localData = ref<StepData>({ ...props.initialData })
const referenceUrl = ref('')
const isAnalyzing = ref(false)

watch(localData, (newData) => {
  emit('update', { ...newData })
}, { deep: true })

const analyzeWithAI = async () => {
  if (!referenceUrl.value || isAnalyzing.value) return

  isAnalyzing.value = true
  try {
    const result = await aiAPI.analyzeWriterUrl(referenceUrl.value)
    if (result.tone_of_voice) {
      localData.value.toneOfVoice = result.tone_of_voice
    }
    if (result.style_guide) {
      localData.value.styleGuide = result.style_guide
    }
    if (result.speech_patterns) {
      localData.value.speechPatternGuidelines = result.speech_patterns
    }
  } catch (error) {
    handleError(error, store)
  } finally {
    isAnalyzing.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "step-title" }, "Create your first writer", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "step-description" }, " A writer defines the voice and style for your content. You can create more writers later. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form-label required" }, "Writer name", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localData.value.name) = $event)),
        type: "text",
        class: "form-input",
        placeholder: "e.g., Blog Writer, Technical Writer"
      }, null, 512), [
        [_vModelText, localData.value.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"ai-section-header\" data-v-976ec32a><div class=\"ai-icon\" data-v-976ec32a><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" data-v-976ec32a><path d=\"M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z\" data-v-976ec32a></path></svg></div><div class=\"ai-section-text\" data-v-976ec32a><h3 class=\"ai-section-title\" data-v-976ec32a>Auto-fill with AI</h3><p class=\"ai-section-subtitle\" data-v-976ec32a>Paste a sample article URL and we&#39;ll extract the writing style</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((referenceUrl).value = $event)),
          type: "url",
          class: "ai-input",
          placeholder: "https://example.com/blog-post",
          onKeydown: _withKeys(analyzeWithAI, ["enter"])
        }, null, 544), [
          [_vModelText, referenceUrl.value]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary ai-analyze-btn",
          disabled: !referenceUrl.value || isAnalyzing.value,
          onClick: analyzeWithAI
        }, [
          (isAnalyzing.value)
            ? (_openBlock(), _createBlock(LoadingSpinner, {
                key: 0,
                size: "sm"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  fill: "currentColor",
                  class: "btn-icon"
                }, [
                  _createElementVNode("path", { d: "M7.156 2.344a.75.75 0 01.594.75v.312c0 1.25.455 2.435 1.28 3.356l.13.15a.75.75 0 01-1.12.992l-.13-.15a6.257 6.257 0 01-1.66-4.348V3.094a.75.75 0 01.906-.75zm5.688 0a.75.75 0 01.906.75v.312a6.257 6.257 0 01-1.66 4.348l-.13.15a.75.75 0 01-1.12-.992l.13-.15a4.757 4.757 0 001.28-3.356V3.094a.75.75 0 01.594-.75zM10 6.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 1.5a2 2 0 110 4 2 2 0 010-4zm-7.5 4a.75.75 0 01.75-.75h.312a4.757 4.757 0 003.356-1.28l.15-.13a.75.75 0 01.992 1.12l-.15.13a6.257 6.257 0 01-4.348 1.66H3.25a.75.75 0 01-.75-.906zm14.156.156a.75.75 0 01.75.75v.312a.75.75 0 01-.75.75h-.312a6.257 6.257 0 01-4.348-1.66l-.15-.13a.75.75 0 01.992-1.12l.15.13a4.757 4.757 0 003.356 1.28h.312a.75.75 0 01.75.438z" })
                ], -1)),
                _cache[7] || (_cache[7] = _createTextVNode(" Analyze ", -1))
              ], 64))
        ], 8, _hoisted_5)
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "divider" }, [
      _createElementVNode("span", { class: "divider-text" }, "or fill in manually")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Tone of voice", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localData.value.toneOfVoice) = $event)),
          class: "form-textarea",
          rows: "3",
          placeholder: "e.g., Professional but approachable, conversational, authoritative..."
        }, null, 512), [
          [_vModelText, localData.value.toneOfVoice]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Style guide", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localData.value.styleGuide) = $event)),
          class: "form-textarea",
          rows: "3",
          placeholder: "e.g., Use active voice, short paragraphs, include examples..."
        }, null, 512), [
          [_vModelText, localData.value.styleGuide]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Speech patterns (optional)", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localData.value.speechPatternGuidelines) = $event)),
          class: "form-textarea",
          rows: "2",
          placeholder: "e.g., Avoid jargon, use 'we' instead of 'I', include rhetorical questions..."
        }, null, 512), [
          [_vModelText, localData.value.speechPatternGuidelines]
        ])
      ])
    ])
  ]))
}
}

})